
import { ref,nextTick,inject, reactive, shallowRef, isReactive,watch,watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import { getCart } from "@/hooks/index";
export default {
  props:{
      active:{
        type:Number,
        default:0
      }
  },
  setup(props:any) {
    const $http: any = inject("$http");
    const router = useRouter()
    
    let cart_goods:any = shallowRef([])
 const $store: any = inject("$store");
   // 获取购物车数量
        if(common.getStorage('access_token')) {  
                if($store.getCart()){     
                    //  cart_goods.value = $store.getCart()
                }else {
                      getCart().then((ret) => {
                        // ret.forEach((goods_item:any) => {
                    // cart_goods.value = ret
                    // })
                      })
                }
          }
     
    return {
       cart_goods,
       $store,
    }
  }
}
